"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _framerMotion = require("framer-motion");

var _makeStyles = _interopRequireDefault(require("@material-ui/styles/makeStyles"));

var _useTheme = _interopRequireDefault(require("@material-ui/styles/useTheme"));

var _desktopMenuItem = _interopRequireDefault(require("./desktopMenuItem"));

var _desktopSubContainer = _interopRequireDefault(require("./desktopSubContainer"));

var _desktopSubContent = _interopRequireDefault(require("./desktopSubContent"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var useStyles = (0, _makeStyles.default)(function (theme) {
  return {
    root: {
      overflow: "hidden"
    },
    container: {
      display: "flex",
      margin: theme === null || theme === void 0 ? void 0 : theme.spacing(0, -2)
    },
    parent: {
      padding: theme === null || theme === void 0 ? void 0 : theme.spacing(2)
    }
  };
});

var Desktop = function Desktop(_ref) {
  var _mainmenu$items;

  var desktopSubContainerEvent = _ref.desktopSubContainerEvent,
      desktopSubContainerLayoutColumn = _ref.desktopSubContainerLayoutColumn,
      iconClose = _ref.iconClose,
      mainmenu = _ref.mainmenu,
      onClose = _ref.onClose,
      onOpen = _ref.onOpen;

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      menuOpenID = _useState2[0],
      setMenuOpenID = _useState2[1];

  var _useState3 = (0, _react.useState)([]),
      _useState4 = _slicedToArray(_useState3, 2),
      submenu = _useState4[0],
      setSubmenu = _useState4[1];

  var closeTimeout = null;
  var css = useStyles();
  var theme = (0, _useTheme.default)();
  var animation = {
    hidden: {
      opacity: 0,
      y: -(theme === null || theme === void 0 ? void 0 : theme.spacing(3))
    },
    visible: function visible(i) {
      return {
        opacity: 1,
        transition: {
          delay: i * 0.14 + 0.5
        },
        y: 0
      };
    }
  };

  var _handleOpen = function handleOpen(item) {
    cancelClose();

    if ((item === null || item === void 0 ? void 0 : item.items.length) > 0) {
      // timeout because of ClickAwayListener
      setTimeout(function () {
        setMenuOpenID(item.id);
        setSubmenu(item.items);
        if (onOpen) onOpen();
      }, 10);
    }
  };

  var cancelClose = function cancelClose() {
    window.clearTimeout(closeTimeout);
  };

  var _handleClose = function handleClose() {
    var timeout = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 250;
    closeTimeout = setTimeout(function () {
      setMenuOpenID(null);
      setSubmenu([]);
      if (onClose) onClose();
    }, timeout);
  };

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)("menu-01-desktop", css.root)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)("menu-01-desktop-container", css.container)
  }, mainmenu === null || mainmenu === void 0 ? void 0 : (_mainmenu$items = mainmenu.items) === null || _mainmenu$items === void 0 ? void 0 : _mainmenu$items.map(function (item, i) {
    var _item$icon;

    return /*#__PURE__*/_react.default.createElement(_framerMotion.motion.div, {
      className: (0, _clsx.default)("menu-01-desktop-menuitem-parent", css.parent),
      key: item.id,
      custom: i,
      initial: "hidden",
      animate: "visible",
      variants: animation
    }, /*#__PURE__*/_react.default.createElement(_desktopMenuItem.default, {
      action: desktopSubContainerEvent,
      key: item.id,
      handleOpen: function handleOpen() {
        return _handleOpen(item);
      },
      handleClose: function handleClose() {
        return _handleClose();
      },
      hasChildren: item.items && (item === null || item === void 0 ? void 0 : item.items.length) > 0,
      icon: (_item$icon = item.icon) === null || _item$icon === void 0 ? void 0 : _item$icon.filename,
      level: 1,
      link: item.link,
      selected: item.selected,
      target: item.target,
      title: item.title
    }));
  }))), menuOpenID > 0 && /*#__PURE__*/_react.default.createElement(_desktopSubContainer.default, {
    action: desktopSubContainerEvent,
    iconClose: iconClose,
    disableClose: function disableClose() {
      return cancelClose();
    },
    handleClose: function handleClose(timeout) {
      return _handleClose(timeout);
    }
  }, /*#__PURE__*/_react.default.createElement(_desktopSubContent.default, {
    desktopSubContainerLayoutColumn: desktopSubContainerLayoutColumn,
    submenu: submenu
  })));
};

Desktop.propTypes = {
  desktopSubContainerEvent: _propTypes.default.string.isRequired,
  desktopSubContainerLayoutColumn: _propTypes.default.string.isRequired,
  iconClose: _propTypes.default.string.isRequired,
  mainmenu: _propTypes.default.object.isRequired,
  onClose: _propTypes.default.func,
  onOpen: _propTypes.default.func
};
var _default = Desktop;
exports.default = _default;